import { render } from "./CardProgramaXilema.vue?vue&type=template&id=289a6696&scoped=true"
import script from "./CardProgramaXilema.vue?vue&type=script&lang=js"
export * from "./CardProgramaXilema.vue?vue&type=script&lang=js"

import "./CardProgramaXilema.vue?vue&type=style&index=0&id=289a6696&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289a6696"]])

export default __exports__